import { ScheduleTimePeriod } from './ScheduleTimePeriod'
import React from 'react'
import { AddTimeBtn } from '../../../../buttons/AddTimeBtn/AddTimeBtn'
import { generateTimePeriod, TIME_PERIODS, TimePeriod } from './lib/PluginSchedule'

interface ScheduleTimesProps {
    schema: any
    timePeriods: Array<TimePeriod>
    dataPath: string[]
    onTimeAdd: (path: string[], data: any) => void
    onTimeDelete: (path: string[], data: TimePeriod[], errorKeyName: string) => void
    onStartTimeChange: (path: string[], time: string) => void
    onEndTimeChange: (path: string[], time: string | null) => void
}

export const ScheduleTimes = (props: ScheduleTimesProps) => {
    const {
        timePeriods,
        dataPath,
        onTimeAdd,
        onTimeDelete,
        onStartTimeChange,
        onEndTimeChange,
    } = props

    const path = [...dataPath, TIME_PERIODS]

    const handleAddTime = () => {
        onTimeAdd(path, generateTimePeriod())
    }

    return (
        <>
            {timePeriods.map((timePeriod, index: number) => (
                <ScheduleTimePeriod
                    key={timePeriod.element_id}
                    index={index}
                    dataPath={path}
                    timePeriod={timePeriod}
                    timePeriods={timePeriods}
                    onStartTimeChange={onStartTimeChange}
                    onEndTimeChange={onEndTimeChange}
                    onTimeDelete={onTimeDelete}
                />
            ))}
            <AddTimeBtn
                handleTimeAdd={handleAddTime}
                className="fit-content"
            />
        </>
    )
}
